import { Modal, Button } from "@shared/components/ui";
import { Sparkles, CheckCircle } from "lucide-react";

type UpgradeSuccessModalProps = {
  isOpen: boolean;
  onClose: () => void;
};

const PRO_BENEFITS = [
  { name: "Staff Scheduling", description: "Create and manage employee schedules and time tracking." },
  { name: "Photo Sharing", description: "Share activity photos with parents throughout the day." },
  { name: "Flat-Rate Pricing", description: "Simple monthly pricing with no per-child fees." },
  { name: "Unlimited Children", description: "No cap on the number of children in your center." },
  { name: "Unlimited Classrooms", description: "Add as many classrooms as you need." },
  { name: "Priority Support", description: "Get faster responses from our support team." },
];

export function UpgradeSuccessModal({ isOpen, onClose }: UpgradeSuccessModalProps) {
  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <div className="max-w-lg mx-auto text-center">
        <div className="mx-auto mb-3 flex h-12 w-12 items-center justify-center rounded-full bg-success-bg">
          <Sparkles className="h-6 w-6 text-success-text" />
        </div>

        <h2 className="text-xl font-semibold font-display text-foreground">
          Welcome to Pro!
        </h2>
        <p className="mt-1 text-sm text-muted">
          Here's what's included with your Pro plan:
        </p>

        <ul className="mt-4 grid grid-cols-1 gap-2 text-left">
          {PRO_BENEFITS.map((benefit) => (
            <li
              key={benefit.name}
              className="flex items-start gap-2.5 rounded-lg bg-success-bg/50 px-3 py-2"
            >
              <CheckCircle className="mt-0.5 h-4 w-4 flex-shrink-0 text-success-text" />
              <div>
                <span className="text-sm font-medium text-foreground">
                  {benefit.name}
                </span>
                <p className="text-xs text-muted">{benefit.description}</p>
              </div>
            </li>
          ))}
        </ul>

        <div className="mt-5">
          <Button onClick={onClose}>Get Started</Button>
        </div>
      </div>
    </Modal>
  );
}
